export const tabs = [
  {
    id: 0,
    tabName: 'Investments',
    disabled: false,
    filters: [
      {
        id: '0',
        filterName: 'Report ID',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '1',
        filterName: 'Donor Name',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '2',
        filterName: 'Portfolio',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '3',
        filterName: 'Portfolio Year',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '4',
        filterName: 'NPO Name',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '5',
        filterName: 'Funded Program Name',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '6',
        filterName: 'Cash Value',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '7',
        filterName: 'Cash Description',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '8',
        filterName: 'Goods Value',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '9',
        filterName: 'Goods Description',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '10',
        filterName: 'Volunteerism Value',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '11',
        filterName: 'Volunteerism Description',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '12',
        filterName: 'Services Value',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '13',
        filterName: 'Services Description',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '14',
        filterName: 'Total Investment',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '15',
        filterName: 'NPO Contact First Name',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '16',
        filterName: 'NPO Contact Last Name',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '17',
        filterName: 'NPO Contact Email',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '18',
        filterName: 'Relationship Manager',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '19',
        filterName: 'Report Feedback Preferences',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '20',
        filterName: 'Allocated Investment',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '21',
        filterName: 'Investment Type',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '22',
        filterName: 'Portion Funded and Donor Claim',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '23',
        filterName: 'External ID',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '24',
        filterName: 'Portion Funded',
        checked: false,
        disabled: false,
        tabId: '0'
      },
      {
        id: '25',
        filterName: 'Donor Claim',
        checked: false,
        disabled: false,
        tabId: '0'
      }
    ]
  },
  {
    id: 1,
    tabName: 'Overview',
    disabled: false,
    filters: [
      {
        id: '0',
        filterName: 'Report Name',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '1',
        filterName: 'NPO Account Name',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '2',
        filterName: 'Start Date',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '3',
        filterName: 'End Date',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '4',
        filterName: 'Service Name',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '5',
        filterName: 'Report Stage',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '6',
        filterName: 'Report Status',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '7',
        filterName: 'Report Description',
        checked: false,
        disabled: false,
        tabId: '1'
      },
      {
        id: '8',
        filterName: 'Last Updated',
        checked: false,
        disabled: false,
        tabId: '1'
      }
    ]
  },
  {
    id: 2,
    tabName: 'Intervention',
    disabled: false,
    filters: [
      {
        id: '0',
        filterName: 'Core service (categorical)',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '1',
        filterName: 'Primary intervention types',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '2',
        filterName: 'Secondary intervention type',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '3',
        filterName: 'Tertiary intervention type',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '4',
        filterName: 'Intervention dosage level',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '5',
        filterName: 'Intervention dosage number',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '6',
        filterName: 'Social Category',
        checked: false,
        disabled: false,
        tabId: '2'
      },
      {
        id: '7',
        filterName: 'Intervention Info',
        checked: false,
        disabled: false,
        tabId: '2'
      }
    ]
  },
  {
    id: 3,
    tabName: 'Beneficiaries',
    disabled: false,
    sections: [
      {
        id: '0',
        title: 'Section 1. Please select the type of data you wish to export',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'Beneficiary Description',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'Beneficiary Location 1',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'Beneficiary Location 2',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'Beneficiary Location 3',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'Beneficiary Location 5',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'Beneficiary Location 6',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '6',
            filterName: 'Beneficiary Location 7',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '7',
            filterName: 'Beneficiary Location 8',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '8',
            filterName: 'Beneficiary Location 9',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '9',
            filterName: 'Beneficiary Location 10',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      },
      {
        id: '1',
        title: 'Category: Age & Identity',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'Children and youth',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'Children and youth (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'Infants and toddlers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'Infants and toddlers (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'Children',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'Children (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '6',
            filterName: 'Preteens',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '7',
            filterName: 'Preteens (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '8',
            filterName: 'Adolescents',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '9',
            filterName: 'Adolescents (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '10',
            filterName: 'K-12',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '11',
            filterName: 'K-12 (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '12',
            filterName: 'Adults',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '13',
            filterName: 'Adults (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '14',
            filterName: 'Seniors',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '15',
            filterName: 'Seniors (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '16',
            filterName: 'Females',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '17',
            filterName: 'Females (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '18',
            filterName: 'Males',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '19',
            filterName: 'Males (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '20',
            filterName: 'LGBTQ',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '21',
            filterName: 'LGBTQ (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      },
      {
        id: '2',
        title: 'Category: Ethnic & Racial Groups',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'People of Middle Eastern descent',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'People of Middle Eastern descent (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'People of Asian descent',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'People of Asian descent (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'People of African descent',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'People of African descent (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '6',
            filterName: 'People of European descent',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '7',
            filterName: 'People of European descent (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '8',
            filterName: 'People of Latin American descent',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '9',
            filterName: 'People of Latin American descent (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '10',
            filterName: 'Indigenous peoples',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '11',
            filterName: 'Indigenous peoples (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '12',
            filterName: 'Multiracial people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '13',
            filterName: 'Multiracial people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      },
      {
        id: '3',
        title: 'Category: Social & Economic Status',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'Immigrants and migrants',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'Immigrants and migrants (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'Economically disadvantaged people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'Economically disadvantaged people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'Homeless people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'Extremely poor people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '6',
            filterName: 'Extremely poor people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '7',
            filterName: 'Incarcerated people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '8',
            filterName: 'Incarcerated people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '9',
            filterName: 'At-risk youth',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '10',
            filterName: 'At-risk youth (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '11',
            filterName: 'Victims and oppressed people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '12',
            filterName: 'Victims and oppressed people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      },
      {
        id: '4',
        title: 'Category: Health',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'People with disabilities',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'People with disabilities (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'People with diseases and illnesses',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'People with diseases and illnesses (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'Substance abusers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'Substance abusers (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      },
      {
        id: '5',
        title: 'Category: Work Status & Occupations',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'Domestic workers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '1',
            filterName: 'Domestic workers (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '2',
            filterName: 'Unemployed people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '3',
            filterName: 'Unemployed people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '4',
            filterName: 'Self-employed people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '5',
            filterName: 'Self-employed people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '6',
            filterName: 'Retired people',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '7',
            filterName: 'Retired people (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '8',
            filterName: 'Students',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '9',
            filterName: 'Students (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '10',
            filterName: 'Military personnel',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '11',
            filterName: 'Military personnel (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '12',
            filterName: 'Veterans',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '13',
            filterName: 'Veterans (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '14',
            filterName: 'Farmers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '15',
            filterName: 'Farmers (%)',
            checked: false,
            disabled: true,
            tabId: '3'
          },
          {
            id: '16',
            filterName: 'Emergency responders',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '17',
            filterName: 'Emergency responders (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '18',
            filterName: 'Artists and performers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '19',
            filterName: 'Artists and performers (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '20',
            filterName: 'Sex workers',
            checked: false,
            disabled: false,
            tabId: '3'
          },
          {
            id: '21',
            filterName: 'Sex workers (%)',
            checked: false,
            disabled: false,
            tabId: '3'
          }
        ]
      }
    ]
  },
  {
    id: 4,
    tabName: 'Impacts',
    disabled: false,
    sections: [
      {
        id: '0',
        title:
          'Section 1. Please select the type of data you wish to export (this will apply to each indicator selected in the next section)',
        header: true,
        filters: [
          {
            id: '0',
            filterName: 'Indicator Name',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '1',
            filterName: 'Description',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '2',
            filterName: 'Success Criteria',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '3',
            filterName: 'Sources Assumptions',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '4',
            filterName: 'Measurement Type',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '5',
            filterName: 'Initial Forecast',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '6',
            filterName: 'Current Forecast',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '7',
            filterName: 'Forecast Variance',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '8',
            filterName: 'Current Forecast (funded claim)',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '9',
            filterName: 'Current Forecast (full claim)',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '10',
            filterName: 'Current Forecast (catalyzed)',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '11',
            filterName: 'Leverage (%)',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '12',
            filterName: 'SROI per $10k (funded claim)',
            checked: false,
            disabled: false,
            tabId: '4'
          },
          {
            id: '13',
            filterName: 'SROI per $10k (full claim)',
            checked: false,
            disabled: false,
            tabId: '4'
          }
        ]
      },
      {
        id: '1',
        title:
          'Section 2. Please select the indicators you wish to export for your report',
        header: true,
        filters: []
      }
    ]
  },
  {
    id: 5,
    tabName: 'Narrative',
    disabled: false,
    filters: [
      {
        id: '0',
        filterName: 'Success Stories',
        checked: false,
        disabled: false,
        tabId: '5'
      },
      {
        id: '1',
        filterName: 'Lessons Learned',
        checked: false,
        disabled: false,
        tabId: '5'
      }
    ]
  },
  {
    id: 6,
    tabName: 'Budget',
    disabled: false,
    filters: [
      {
        id: '0',
        filterName: 'Total Costs',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '1',
        filterName: 'Total Budget (initial)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '2',
        filterName: 'Total Budget (variance)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '3',
        filterName: 'Direct Cash (current)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '4',
        filterName: 'Indirect Cash (current)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '5',
        filterName: 'Direct Inkind (current)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '6',
        filterName: 'Indirect Inkind (current)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '7',
        filterName: 'Direct Cash (initial)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '8',
        filterName: 'Indirect Cash (initial)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '9',
        filterName: 'Direct Inkind (initial)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '10',
        filterName: 'Indirect Inkind (initial)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '11',
        filterName: 'Direct Cash Comment',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '12',
        filterName: 'Indirect Cash Comment',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '13',
        filterName: 'Direct Inkind Comment',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '14',
        filterName: 'Indirect Inkind Comment',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '15',
        filterName: 'Budget Note 1',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '16',
        filterName: 'Budget Note 1 date',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '17',
        filterName: 'Budget Note 2',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '18',
        filterName: 'Budget Note 2 date',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '19',
        filterName: 'Additional Budget Notes (#)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '20',
        filterName: 'Direct Cash (variance)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '21',
        filterName: 'Indirect Cash (variance)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '22',
        filterName: 'Direct Inkind (variance)',
        checked: false,
        disabled: false,
        tabId: '6'
      },
      {
        id: '23',
        filterName: 'Indirect Inkind (variance)',
        checked: false,
        disabled: false,
        tabId: '6'
      }
    ]
  }
];
